import { paymentActionTypes } from '~/store/legacy/actions/paymentActions.js';

const initState = {
  loaded: false,
  failed: false,
  selectedMethod: null,
  methods: [],
  errorMessage: '',
};

const handleGetPaymentMethodsSuccess = (state, action) => {
  const nonBrainTreePayments = action.methods.filter((method) => method.processor !== 'braintree');
  return {
    ...state,
    ...{
      loaded: action.loaded,
      failed: false,
      selectedMethod:
        !state.selectedMethod && nonBrainTreePayments.length > 0
          ? nonBrainTreePayments[0]
          : state.selectedMethod,
      methods: nonBrainTreePayments,
    },
  };
};

const PaymentReducer = (state = initState, action) => {
  switch (action.type) {
    case paymentActionTypes.getPaymentMethodsStart:
    case paymentActionTypes.addPaymentMethodStart:
    case paymentActionTypes.removePaymentMethodStart:
      return {
        ...state,
        ...{
          loaded: false,
          failed: false,
        },
      };

    case paymentActionTypes.addPaymentMethodSuccess:
      return {
        ...state,
        ...{
          loaded: true,
          failed: false,
          selectedMethod: action.selectedMethod,
        },
      };

    case paymentActionTypes.addPaymentMethodFailed:
      return {
        ...state,
        ...{
          loaded: true,
          failed: true,
          errorMessage: action.errorMessage,
        },
      };

    case paymentActionTypes.getPaymentMethodsSuccess:
      return handleGetPaymentMethodsSuccess(state, action);

    case paymentActionTypes.getPaymentMethodsFailed:
      return {
        ...state,
        ...{
          loaded: action.loaded,
          failed: true,
        },
      };

    case paymentActionTypes.removePaymentMethodSuccess:
      return {
        ...state,
        ...{
          loaded: true,
          failed: false,
          selectedMethod:
            state.selectedMethod.identity === action.method.identity ? null : state.selectedMethod,
          methods: state.methods.filter((method) => method.identifier !== action.method.identifier),
        },
      };

    case paymentActionTypes.removePaymentMethodFailed:
      return {
        ...state,
        ...{
          loaded: true,
          failed: true,
        },
      };

    case paymentActionTypes.choosePaymentMethod:
      return {
        ...state,
        ...{
          selectedMethod: action.method,
        },
      };

    case paymentActionTypes.resetPaymentError:
      return {
        ...state,
        ...{
          errorMessage: action.errorMessage,
        },
      };

    default:
      return state;
  }
};

export default PaymentReducer;
